import React, {useEffect, useState} from 'react';
import './SensorSelect.scss';
import SensorItem from "./SensorItem/SensorItem";
import SensorDetail from "./SensorDetail/SensorDetail";
import CheckList from "./CheckList/CheckList";
import Introduction from "./Introduction/Introduction";
import Modal from './common/Modal/Modal';
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';
import Button from '../../partials/Button';


function SensorSelect( { data, onComplete, doComplete, breadcrumbs, goBackToPreviousSegment, ...rest }) {
    const { sensors } = data || {}
    const { intro } = data
    if (!sensors) {
        throw new Error('No sensors in input props')
    }
    const [showIntro, setShowIntro ] = useState(true)
    const [ theSensor, setTheSensor ] = useState()
    const [ sensorDetailShow, setSensorDetailShow ] = useState(true);

    const [ currentSelectedSensorType, setCurrentSelectedSensorType ] = useState();
    const [ currentSelectedSensor, setCurrentSelectedSensor ] = useState();
    const [ currentSelectedSensorSubtype, setCurrentSelectedSensorSubtype ] = useState(0);

    const [ chosenSensor, setChosenSensor ] = useState();
    const [ viewedSensors, setViewedSensors ] = useState([])

    const [ mReqDialogShow, setMReqDialogShow ] = useState(false);
    const [ sensorInfoDialogShow, setSensorInfoDialogShow ] = useState(false);
    

    const chooseSensorType = (e) => {
        // Reset of sensor selection
        setCurrentSelectedSensor();
        setCurrentSelectedSensorSubtype();
        setCurrentSelectedSensorType(e);
    }

    const chooseSensor = (id) => {
        setCurrentSelectedSensorSubtype();
        setCurrentSelectedSensor(id);
    };
    const handleSensorDetailModalContinue = (decision, sensor) => {
        if (decision === 'accepted') {
            setChosenSensor(sensor)
        } else if (decision === 'rejected') {
            setViewedSensors([...viewedSensors, sensor])
        }
        setSensorDetailShow(false)
    }
    const handleOnComplete = (sensor, checklist) => {
            onComplete(sensor)
    }
    const handleOnRestart = () => {
            setChosenSensor()
            setCurrentSelectedSensor()
            setCurrentSelectedSensorType()
            setCurrentSelectedSensorSubtype()
            setShowIntro(true)
    }

    useEffect( () => {
        if (doComplete) {
            doComplete(chosenSensor)
        }
    }, [chosenSensor])
    useEffect( () => {
        console.log("VIEWED SENSORS: ",viewedSensors)
    }, [viewedSensors])
    useEffect(() => {
        const currentSensor = sensors[currentSelectedSensorType]?.types[currentSelectedSensor]
        if (currentSensor) {
            if (typeof currentSensor.types === "undefined") {
                setTheSensor(currentSensor)
                return
            }
            const isSubTypeSelected =  currentSensor.types[currentSelectedSensorSubtype]
            if (isSubTypeSelected) {
                setTheSensor(isSubTypeSelected)
            }
        }
    },[sensors, currentSelectedSensorType, currentSelectedSensor, currentSelectedSensorSubtype ])

    useEffect(() => {

            setSensorDetailShow(theSensor !== "undefined")

    }, [theSensor])

    return (
        <InteractionContainer withFrame={true} breadcrumbs={breadcrumbs}>
            <div className="sensor-select">
                <div class="back-btn-container">
                    <Button variant='back' text="Back" onClick={goBackToPreviousSegment} />
                </div>
                <div className="mission-req">
                    { data.missionRequirements &&
                        <Button onClick={() => { setMReqDialogShow(true); }} text={data.missionRequirementsText} />
                    }
                </div>
                <div className="helpful-links">
                    {/* Mission Requirements modal */}
                    <Modal 
                        size={'medium'}
                        show={mReqDialogShow}
                        showContinue={false}
                        onContinueClick={ () => {
                            setMReqDialogShow(false);
                        }}>
                        <div className="mReq-Header" style={{color:"#fff",p:{fontSize: "16px"}}} dangerouslySetInnerHTML={{ __html: data.missionRequirements}}></div>
                        <div style={{textAlignLast:"center"}}>
                            <Button text={data.closeButtonText} onClick={()=>setMReqDialogShow(false)}/>
                        </div>
                    </Modal>
                </div>
            <h2 className="mainheading-class">{data.mainHeader}</h2>
        <div className="container">
            <SensorDetail show={sensorDetailShow}
                          sensor={theSensor}
                          onClose={handleSensorDetailModalContinue}
                          missionRequirements={data.missionRequirements}
                          missionRequirementsText={data.missionRequirementsText}
                          closeButtonText={data.closeButtonText}
            />
            {chosenSensor && <CheckList
                sensor={chosenSensor}
                checklistsummarytitle={data.checklistsummarytitle}
                retryButtonText={data.retryButtonText}
                onComplete={handleOnComplete}
                onRestart={handleOnRestart}
            />}
            {!chosenSensor && <>
                <div style={{display:"flex"}}>
            <div className="left-panel">
                <div className="sensor-type-wrapper">
                    <div className="sensor-type-selection">
                        <h2>Select a Sensor Type</h2>
                        <div className="sensor-type-options">
                            {
                                Object.keys(sensors).map((sensorType) => {
                                    return <SensorItem
                                        key={sensorType}
                                        sensor={{type: sensorType, img: sensors[sensorType].img, alt: sensors[sensorType].alt }}
                                        active={currentSelectedSensorType === sensorType}
                                        onChoose={() => {
                                            chooseSensorType(sensorType)
                                        }}/>
                                })
                            }
                        </div>
                    </div>
                </div>
                <div>
                    {currentSelectedSensorType&&
                        <div className="info-container">
                            <div className="info-header">
                                <p>What is a {currentSelectedSensorType} Sensor?</p>
                            </div>
                            <div className="info-body">
                            {/* <img src={sensors[currentSelectedSensorType]?.img} width={`60%`} style={{marginTop: '1rem', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}  alt={sensors[currentSelectedSensorType]?.type} /> */}
                                <p>{sensors[currentSelectedSensorType]?.definition}</p>
                            </div>
                        </div>
                    }
                </div>
            </div>
            <div className="right-panel">
            {currentSelectedSensorType &&
                <div className="sensors-list-wrapper">
                    <h2>Please choose one {currentSelectedSensorType} sensor!</h2>
                    <div className="sensors-list">
                        {
                            sensors[currentSelectedSensorType].types.map((sensor, sensorIndex) => (
                                    // Render Sensors with Subtypes here
                                    <React.Fragment key={sensor.type}>
                                        {sensor.types && <div className="sensor-option" style={{position: 'relative'}}>
                                            <SensorItem sensor={sensor} active={currentSelectedSensor === sensorIndex}
                                                        isViewed={typeof viewedSensors.find(v => v.type === sensor.type) !== "undefined"}

                                                        onChoose={(ss) => {
                                                            chooseSensor(sensorIndex);
                                                        }}/>
                                            {currentSelectedSensor === sensorIndex &&
                                            <div className="popover">
                                                <h2>{sensor.type} Types </h2>
                                                {
                                                    Object.keys(sensor.types).map((s, i) => (
                                                        <SensorItem
                                                            key={s}
                                                            isViewed={typeof viewedSensors.find(v => v.type === sensor.types[s].type) !== "undefined"}
                                                            sensor={sensor.types[s]}
                                                            active={currentSelectedSensorSubtype === i}
                                                            onChoose={(ss) => {
                                                                setCurrentSelectedSensorSubtype(i,);
                                                                setTheSensor(ss)
                                                            }}/>
                                                    ))
                                                }
                                            </div>
                                            }
                                        </div>}
                                        {/* Render Sensors without Subtypes  */}
                                        {!sensor.types &&
                                        <SensorItem sensor={sensor}
                                                    isViewed={typeof viewedSensors.find(v => v.type === sensor.type) !== "undefined"}
                                                    active={currentSelectedSensor === sensorIndex}
                                                    onChoose={(ss) => {
                                                        chooseSensor(sensorIndex)
                                                        setTheSensor(ss)
                                                        setSensorDetailShow(true)
                                                    }}/>
                                        }
                                    </React.Fragment>
                                )
                            )
                        }
                    </div>
                </div>
            }
        </div>
    </div>
    </>}

        </div>
        </div>
        </InteractionContainer>
    );
}
export default SensorSelect;
